// extracted by mini-css-extract-plugin
export var layout = "Layout-module--layout--Xc7Ik";
export var navPlaceholder = "Layout-module--navPlaceholder--x6uql";
export var layoutBox = "Layout-module--layoutBox--0wGxU";